<template>
  <div class="modalContainer">
    <div class="printContainer" ref="printHideDomRef" v-show="!isShowImg">
      <div class="titleContainer">
        <h1>差 旅 费 报 销 单</h1>
      </div>

      <div class="dateContainer">
        <div>报销日期: {{ this.ykDateFormat('yyyy-MM-dd', this.printData.r_date) }}</div>
        <div>公司: {{ this.printData.company }}</div>
      </div>

      <table class="mainTable">
        <tr>
          <td colspan="5" rowspan="2" align="left">出差事由:&nbsp;{{ this.printData.subject_matter }}</td>
          <td colspan="2" rowspan="2">出差天数</td>
          <td colspan="4">
            {{ this.ykDateFormat('yyyy-MM-dd', this.printData.e_begin_date) }} 至
            {{ this.ykDateFormat('yyyy-MM-dd', this.printData.e_end_date) }}
          </td>
        </tr>
        <tr>
          <td colspan="4">共 {{ this.printData.e_day_count }} 天</td>
        </tr>
        <tr>
          <td rowspan="2" style="width: 60px !important;">日期</td>
          <td rowspan="2" style="width: 120px !important;">起讫地点</td>
          <td colspan="3">交通费</td>
          <td colspan="2">住宿费</td>
          <td rowspan="2" style="width: 80px !important">误餐补助</td>
          <td rowspan="2" style="width: 80px !important">公杂费</td>
          <td rowspan="2" style="width: 80px !important;">合计</td>
          <td rowspan="2" style="width: 50px;">备注</td>
        </tr>
        <tr>
          <td style="width: 80px;">类别</td>
          <td style="width: 30px;">票据张数</td>
          <td style="width: 70px;">含税金额</td>
          <td style="width: 30px;">票据张数</td>
          <td style="width: 70px;">含税金额</td>
        </tr>

        <tr v-for="(item, index) of DetailList" :key="index">
          <td>{{ item.date }}</td>
          <td>{{ item.address }}</td>
          <td>{{ item.traffic_type }}</td>
          <td>{{ item.traffic_invoice_count }}</td>
          <td>{{ item.traffic_invoice_amount }}</td>
          <td>{{ item.stay_invoice_count }}</td>
          <td>{{ item.stay_invoice_amount }}</td>
          <td>{{ item.meal_str }}</td>
          <td>{{ item.miscellaneous_str }}</td>
          <td>{{ item.total_amount }}</td>
          <td>{{ item.memo }}</td>
        </tr>

        <tr>
          <td colspan="2">合 计</td>
          <td></td>
          <td>{{ traffic_sum_count }}</td>
          <td>{{ traffic_sum_amount }}</td>
          <td>{{ stay_sum_count }}</td>
          <td>{{ stay_sum_amount }}</td>
          <td>{{ meal_sum_amount }}</td>
          <td>{{ miscellaneous_sum_amount }}</td>
          <td>
            {{ this.$utils.sum([traffic_sum_amount, stay_sum_amount, meal_sum_amount, miscellaneous_sum_amount]) }}
          </td>
          <td></td>
        </tr>

        <tr>
          <td colspan="4">
            <div style="width: 100%;height: 100%;text-align: left;">
              <span>各项支出合计:</span>
              <br />
              <span style="font-size: 16px;"
                >(￥{{ this.$utils.commafy(this.printData.total_expenses, { digits: 2 }) }})</span
              >
              &nbsp;<span style="font-size: 16px;">{{ this.amountLtoU(this.printData.total_expenses) }}</span>
            </div>
          </td>
          <td colspan="7" style="padding: 0;">
            <table class="detailTable" style="margin: 0;z-index: 9999;background-color: #fff;">
              <tr>
                <td rowspan="4" style="border: 0;width: 30px;">票据张数</td>
                <td style="width: 37px;">{{ this.printData.office_count }}</td>
                <td>办公费 {{ this.printData.office_expenses }} 元</td>
                <td rowspan="4" style="border: 0;width: 30px;">票据张数</td>
                <td style="width: 37px;">{{ this.printData.post_count }}</td>
                <td style="border-right: 0;">邮电费 {{ this.printData.post_expenses }} 元</td>
              </tr>

              <tr>
                <td>{{ this.printData.meal_count }}</td>
                <td>&emsp;餐费 {{ this.printData.meal_expenses }} 元</td>
                <td>{{ this.printData.check_count }}</td>
                <td style="border-right: 0;">检定费 {{ this.printData.check_expenses }} 元</td>
              </tr>

              <tr>
                <td>{{ this.printData.traffic_count }}</td>
                <td>交通费 {{ this.printData.traffic_expenses }} 元</td>
                <td>{{ this.printData.other_count }}</td>
                <td style="border-right: 0;">其他费 {{ this.printData.other_expenses }} 元</td>
              </tr>
            </table>
          </td>
        </tr>
      </table>

      <div class="footerContainer">
        <div class="signContainer">
          领导审批:
          <div class="signItems" v-html="yaozongSign"></div>
        </div>
        <div class="signContainer">
          单位主管:
          <div class="signItems" v-html="lingongSign"></div>
        </div>
        <div class="signContainer">
          财务审核:
          <div class="signItems" v-html="caiwuSign"></div>
        </div>
        <div v-html="personSign"></div>
      </div>
    </div>

    <img id="printImgDom" style="cursor: pointer;width: 100%;" :src="imgSrc" @click="previewImg" v-show="isShowImg" />
  </div>
</template>
<script>
import html2canvas from 'html2canvas'
// import SignObject from '../../public/utils/signJpg'
import { convertSign } from '../../public/utils/getSign'

export default {
  props: {
    printData: {
      type: Object
    }
  },
  data() {
    return {
      formVisible: false,
      // 打印数据
      traffic_sum_count: '',
      traffic_sum_amount: '',
      stay_sum_count: '',
      stay_sum_amount: '',
      meal_sum_amount: '',
      miscellaneous_sum_amount: '',
      yaozongSign: '',
      lingongSign: '',
      caiwuSign: '',
      DetailHtmlList: [],
      DetailList: [],
      personSign: [],
      imgSrc: '',
      // 是否展示图片
      isShowImg: false
    }
  },
  methods: {
    // 预览图片
    previewImg() {
      this.$hevueImgPreview(this.imgSrc)
    },

    showModal() {
      // document.getElementById('printHideDom').innerHTML = ''
      // document.getElementById('printImgDom').src = ''

      this.handlePrint()
    },
    async handlePrint() {
      const { data: res } = await this.$http.get('/finance/users')
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      const SignObject = convertSign(res.data)

      this.isShowImg = false

      this.DetailHtmlList = []
      this.DetailList = []

      this.traffic_sum_count = 0
      this.traffic_sum_amount = 0

      this.stay_sum_count = 0
      this.stay_sum_amount = 0

      this.meal_sum_amount = 0
      this.miscellaneous_sum_amount = 0

      for (const item of this.printData.detailList) {
        this.traffic_sum_count = this.$utils.sum([this.traffic_sum_count, item.traffic_invoice_count])
        this.traffic_sum_amount = this.$utils.sum([this.traffic_sum_amount, item.traffic_invoice_amount])
        this.stay_sum_count = this.$utils.sum([this.stay_sum_count, item.stay_invoice_count])
        this.stay_sum_amount = this.$utils.sum([this.stay_sum_amount, item.stay_invoice_amount])

        this.meal_sum_amount = this.$utils.sum([this.meal_sum_amount, item.meal_Total])
        this.miscellaneous_sum_amount = this.$utils.sum([this.miscellaneous_sum_amount, item.miscellaneous_Total])

        let meal_str = ''
        let miscellaneous_str = ''

        if (item.meal_Total) {
          meal_str = `${item.meal_allowance}*${item.travel_days}=${item.meal_Total}`
        }

        if (item.miscellaneous_Total) {
          miscellaneous_str = `${item.miscellaneous_expenses}*${item.travel_days}=${item.miscellaneous_Total}`
        }

        let total_amount = 0

        for (const key of ['meal_Total', 'miscellaneous_Total', 'traffic_invoice_amount', 'stay_invoice_amount']) {
          total_amount = this.$utils.sum([total_amount, item[key]])
        }

        this.DetailList.push({
          date: this.ykDateFormat('MM-dd', item.begin_date),
          address: `${item.begin_address} ${item.end_address ? '- ' + item.end_address : ''}`,
          traffic_type: `${item.traffic_type}`,
          traffic_invoice_count: `${item.traffic_invoice_count}`,
          traffic_invoice_amount: `${item.traffic_invoice_amount}`,
          stay_invoice_count: `${item.stay_invoice_count}`,
          stay_invoice_amount: `${item.stay_invoice_amount}`,
          total_amount,
          meal_str,
          miscellaneous_str,
          memo: `${item.memo}`
        })
      }

      const detailLineCount = 10
      if (this.DetailList.length < detailLineCount) {
        for (let i = detailLineCount - this.DetailList.length; i > 0; i--) {
          this.DetailList.push({
            date: '',
            address: '',
            traffic_type: '',
            traffic_invoice_count: '',
            traffic_invoice_amount: '',
            stay_invoice_count: '',
            stay_invoice_amount: '',
            total_amount: '',
            memo: ''
          })
        }
      }

      if (this.printData.manager_review && this.printData.document_status > 1) {
        this.lingongSign = `<img src="${SignObject['林源晟']}" />`
      }

      if (this.printData.document_status > 2) {
        this.caiwuSign = `<img src="${SignObject['连燕燕']}" />`
      }

      if (this.printData.document_status > 5) {
        this.yaozongSign = `<img src="${SignObject['姚杨']}" />`
      }

      if (this.printData.users_names) {
        this.personSign = '<div class="signsContainer">出差人:<div class="signItems">'
        const users_names_list = this.printData.users_names.split(',')
        if (users_names_list.length > 3) {
          for (const users_name of users_names_list) {
            if (SignObject[users_name]) {
              this.personSign = this.personSign + `<img src="${SignObject[users_name]}" />`
            } else {
              this.personSign = this.personSign + `<span>${users_name}</span>`
            }
          }
        } else if (users_names_list.length <= 3) {
          const users_names_list = this.printData.users_names.split(',')

          for (const users_name of users_names_list) {
            if (SignObject[users_name]) {
              this.personSign =
                this.personSign + `<img style="width: 70px !important;" src="${SignObject[users_name]}" />`
            } else {
              this.personSign = this.personSign + `<span>${users_name}</span>`
            }
          }
        }
        this.personSign = this.personSign + '</div></div>'
      }

      this.$nextTick(() => {
        html2canvas(this.$refs.printHideDomRef, {
          backgroundColor: null
        }).then(canvas => {
          let dataURL = canvas.toDataURL('image/png')

          // document.getElementById('printImgDom').src = dataURL
          this.imgSrc = dataURL

          this.isShowImg = true
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.modalContainer {
  width: 100%;

  // display: flex;
  // justify-content: center;
  // flex-wrap: wrap;
}

/deep/ .printContainer {
  box-sizing: border-box;
  padding: 10px;
  font-size: 14px;

  width: 774px !important;
  height: 1103px !important;

  overflow: hidden;

  background-color: #fff;
}

/deep/ .dateContainer {
  display: flex;
  justify-content: space-between;
}

/deep/ .titleContainer {
  text-align: center;
  height: 45px;
}

/deep/ .titleContainer h1 {
  font-size: 30px;
  font-weight: 400;
}

/deep/ .footerContainer {
  display: flex;
  justify-content: space-between;
}

/deep/ .footerContainer div {
  width: 30%;
}

/deep/ table {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
}

/deep/ table td {
  box-sizing: border-box;
  padding: 3px;
  border: 1px solid #000000;

  height: 26px;

  font-size: 14px;
}

/deep/ .detailTable tr:first-child td {
  border-top: 0;
}

/deep/ .detailTable tr:last-child td {
  border-bottom: 0;
}

/deep/ .mainTable {
  margin: 5px 0 15px 0;
}

/deep/ .signContainer,
/deep/ .signsContainer {
  position: relative;
}

/deep/ .signItems {
  position: absolute;
  left: 70px;
  top: -10px;
}

/deep/ .signItems img {
  width: 80px;
}

/deep/ .signsContainer .signItems {
  width: 100px;
  display: flex;
  flex-wrap: wrap;
}

/deep/ .signsContainer .signItems img {
  width: 50px;
  flex: 0 0;
  align-self: center;
}
</style>
